import Nav from '../components/Nav';
import SiteFooter from '../components/SiteFooter';

const body = { color: 'var(--muted)', fontSize: '1.05rem', lineHeight: 1.8, marginBottom: '1.1rem' };
const h2 = { fontWeight: 700, letterSpacing: '-0.02em', fontSize: '1.5rem', margin: '2.5rem 0 1rem' };

export default function PrivacyPolicy() {
  return (
    <div className="theme-dark grain">
      <div className="site">
        <Nav
          items={[
            { label: 'Pot Belly Pig Studios', to: '/', active: true },
            { label: 'Slope Sliders', to: '/slope-sliders' },
          ]}
        />

        <section className="container" style={{ paddingTop: 'clamp(8rem, 16vw, 12rem)', paddingBottom: 'clamp(3rem,6vw,5rem)', maxWidth: 760 }}>
          <span className="eyebrow">The fine print</span>
          <h1 className="h2" style={{ marginBottom: '2rem' }}>Privacy Policy &amp; Terms</h1>

          <p style={body}>
            We do not collect personal data. Game progress and settings are stored locally on your
            device and are never transmitted to any server.
          </p>
          <p style={body}>
            We may collect anonymous crash reports solely to identify and fix bugs. No personally
            identifiable information is included.
          </p>

          <h2 style={h2}>Terms of Service</h2>
          <p style={body}>
            By playing Slope Sliders you agree to use the app for personal, non-commercial purposes
            only. The game, its artwork, music and code are &copy; Pot Belly Pig Studios. All rights
            reserved.
          </p>
          <p style={body}>
            <strong style={{ color: 'var(--ink)' }}>In-App Purchases:</strong> All purchases are processed by the Apple App Store or
            Google Play and are subject to their respective terms. All sales are final. Contact
            support if you experience billing issues.
          </p>
          <p style={body}>The game is provided &ldquo;as is&rdquo; without warranty of any kind.</p>
          <p style={{ ...body, marginTop: '2rem' }}>
            Contact: <a href="mailto:support@potbellypigstudios.com" style={{ color: 'var(--accent)' }}>support@potbellypigstudios.com</a>
          </p>
        </section>

        <SiteFooter ctaTitle="Back to the fun stuff?" ctaButton="Play Slope Sliders" ctaTo="/slope-sliders" />
      </div>
    </div>
  );
}
